import * as React from 'react';
import './styles.scss';


export type MenuToggleProps = {
  open: boolean;
  setOpen?: (opened: boolean) => void;
};

export const MenuToggle = ({ open, setOpen }: MenuToggleProps) => {
  if (!setOpen) {
    throw new Error('setOpen must be a valid handler.');
  }

  return (
    <button
      className={'cmp-menu-toggle' + (open ? ' cmp-menu-toggle--open' : '')}
      onClick={() => setOpen(!open)}
      aria-owns="navigation"
      aria-expanded={open}
    >
      <div className="cmp-menu-toggle__top" />
      <div className="cmp-menu-toggle__middle" />
      <div className="cmp-menu-toggle__bottom" />
    </button>
  );
};
